<template>
    <div class="sections-container">
        <div class="header-sections">
            <span class="title-section">Ventas</span>

            <div style="display: flex;
                flex-direction: row;
                margin-top: 20px;">

                  <v-btn
                    append-icon="mdi-download"
                    variant="text"
                    style=" margin-right: 20px;"
                    color="#FF5700"
                    @click="exportExcel">
                      Descargar Registros
                </v-btn>

                <div class="autocomplete-container">
                    <span class="title-filter">POS:</span>

                    <v-select
                       v-model="filterSelected"
                        :items="filterData"
                        item-title="label"
                        item-value="value"
                        density="compact"
                        hide-details="auto"
                        variant="solo"
                        class="no-bg"
                    />
                </div>

                <div class="autocomplete-container">
                    <span class="title-filter">Mes:</span>
                    <v-select
                       v-model="monthSelected"
                        :items="monthData"
                        item-title="value"
                        item-value="value"
                        density="compact"
                        hide-details="auto"
                        variant="solo"
                        class="no-bg"/>
                </div>

            </div>
        </div>

        <div class="row-cards-info-dashboard">

          <div class="card-info-sales">
            <span class="title-card">Efectivo</span>
            <span class="info-card">{{ intToMoney(totalCash) }}</span>
          </div>

          <div class="card-info-sales">
            <span class="title-card">Débito</span>
            <span class="info-card">{{ intToMoney(totalDebit) }}</span>
          </div>

          <div class="card-info-sales">
            <span class="title-card">Crédito</span>
            <span class="info-card">{{ intToMoney(totalCredit)  }}</span>
          </div>

          <div class="card-info-sales">
            <span class="title-card">Transferencia</span>
            <span class="info-card">{{ intToMoney(totalTransfer)  }}</span>
          </div>

          <div class="card-info-sales">
            <span class="title-card">Depósito</span>
            <span class="info-card">{{ intToMoney(totalDeposit)  }}</span>
          </div>

          <div class="card-info-sales">
            <span class="title-card">Total</span>
            <span class="info-card">{{ intToMoney(total)  }}</span>
          </div>

        </div>

        <sales-table :sales="responseData"/>

    </div>
</template>
<script>
import dashboardApi from '@/api/dashboardApi'
import terminalsApi from '@/api/terminalsApi'
import SalesTable from '../tables/SalesTable.vue'
import * as XLSX from 'xlsx/xlsx.mjs'
import moneyTransform from '@/utils/moneyTransform'
export default {
  name: 'CommerciaVueVentas',
  components: {
    SalesTable
  },
  data () {
    const months = [
      'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
      'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'
    ]
    const start = new Date(2025, 5) // Agosto 2025
    const now = new Date()
    const monthData = []
    const current = new Date(start)

    // eslint-disable-next-line no-unmodified-loop-condition
    while (current <= now) {
      const label = `${months[current.getMonth()]} ${current.getFullYear()}`
      monthData.push({ value: label, label })
      current.setMonth(current.getMonth() + 1)
    }

    return {
      filterSelected: 'all',
      filterData: [{ value: 'all', label: 'Todos' }],
      monthData,
      monthSelected: monthData[monthData.length - 1].value,
      responseData: [],
      totalCash: 0,
      totalDebit: 0,
      totalCredit: 0,
      totalTransfer: 0,
      totalDeposit: 0,
      total: 0
    }
  },
  computed: {
    busines () {
      return this.$store.getters.business
    }
  },
  created () {
    this.getPos()
  },
  watch: {
    filterSelected (newVal, oldVal) {
      this.getData()
    },
    monthSelected: {
      deep: true,
      immediate: true,
      handler (_, v) {
        this.getData()
      }
    }
  },

  methods: {
    intToMoney (val) { return moneyTransform.intToMoney(val) },
    async getPos () {
      if (this.busines) {
        const listPos = await terminalsApi.list(this.busines._id, '')
        for (const item of listPos) {
          this.filterData.push({ value: item._id, label: item.name })
        }
      }
    },
    async getData () {
      if (this.busines) {
        const valuesDates = this.getMonthRange(this.monthSelected)
        this.responseData = await dashboardApi.adminMonth(
          this.busines._id,
          valuesDates.start,
          valuesDates.end,
          this.filterSelected
        )

        this.totalCash = 0
        this.totalDebit = 0
        this.totalCredit = 0
        this.totalTransfer = 0
        this.totalDeposit = 0
        this.total = 0

        for (const item of this.responseData) {
          this.totalCash += item.cash
          this.totalDebit += item.debit
          this.totalCredit += item.credit
          this.totalTransfer += item.transfer
          this.totalDeposit += item.deposit
          this.total += item.cash + item.debit + item.credit + item.transfer + item.deposit
        }
      }
    },
    getMonthRange (label) {
      const months = {
        Enero: 0,
        Febrero: 1,
        Marzo: 2,
        Abril: 3,
        Mayo: 4,
        Junio: 5,
        Julio: 6,
        Agosto: 7,
        Septiembre: 8,
        Octubre: 9,
        Noviembre: 10,
        Diciembre: 11
      }

      const [mesStr, anioStr] = label.split(' ')
      const month = months[mesStr]
      const year = parseInt(anioStr)
      const start = new Date(year, month, 1, 0, 0, 0, 0).getTime()
      const end = new Date(year, month + 1, 0, 23, 59, 59, 999).getTime()

      return { start, end }
    },
    async exportExcel () {
      console.log(this.responseData)
      const dataExcel = []
      dataExcel.push([
        'Fecha',
        'Efectivo',
        'Débito',
        'Crédito',
        'Transferencia',
        'Depósito',
        'Total',
        'Notas'])

      for (const item of this.responseData) {
        dataExcel.push(
          [
            item.date,
            item.cash,
            item.debit,
            item.credit,
            item.transfer,
            item.deposit,
            item.cash + item.debit + item.credit + item.transfer + item.deposit,
            item.cancel > 0 ? item.cancel + 'cancelados' : 'Sin cancelados'
          ]
        )
      }

      dataExcel.push(
        [
          'TOTAL',
          this.totalCash,
          this.totalDebit,
          this.totalCredit,
          this.totalTransfer,
          this.totalDeposit,
          this.total
        ]
      )

      const workbook = XLSX.utils.book_new()
      const data = XLSX.utils.aoa_to_sheet(dataExcel)
      const boock = this.monthSelected
      XLSX.utils.book_append_sheet(workbook, data, boock)
      XLSX.writeFile(workbook, 'Reporte ' + this.monthSelected + '.xlsx')
    }
  }
}
</script>

<style scoped>
@import '@/assets/styles/sections.css';
@import '@/assets/styles/inputs.css';
@import '@/assets/styles/dashboard.css';
</style>
